import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "../../../@types/client";
const findClients = createAsyncThunk("clients/find", async (searchText, { rejectWithValue }) => {
  try {
    const findMethod = async (model: string) => {
      const url = new URL(`${api.baseURL}${model}`);
      url.searchParams.append(
        "where",
        JSON.stringify({
          enabled: true,
        }),
      );
      url.searchParams.append("sort", "name ASC");
      url.searchParams.append("limit", "50000");

      

      try {
        const token = localStorage.getItem("token");
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${token}`);
        headers.append("Content-Type", "application/json");

        const response = await fetch(url.toString(), {
          method: "GET",
          headers: headers,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Fetch error:", error);
        throw error;
      }
    };

    try {
      const [clients, clientsVigilancia] = await Promise.all([
        findMethod("client"),
        findMethod("clientvigilancia"),
      ]);
      return [...clients, ...clientsVigilancia];
    } catch (error) {
      console.error("Error fetching data:", error);
      return rejectWithValue(error);
    }
  } catch (error) {
    return rejectWithValue(error);
  }
});

export default findClients;
